<template>
  <div class="report-shopdata">
    <div class="module-item-style">
      <el-cascader
        v-model="defaultShop"
        :options="dataoptions"
        :props="{ expandTrigger: 'hover'}"
        @change="selectChange"
        :show-all-levels="false"
      ></el-cascader>
    </div>
    <div class="module-item-style">
      <div class="module-item-title-border-left">访问会员购买率数据统计</div>
      <div class="visitor-statistical-container">
        <div class="data-detail detail-ball">
          <div style="position: relative;">
            <div class="boll">
              <div class="text">
                <p class="num">
                  {{shopDataYesterday.purchaseScale ?
                  Math.round(shopDataYesterday.purchaseScale * 100) : '0'}}
                  <span>%</span>
                </p>
              </div>
              <div ref="water1" class="water w1"></div>
              <div ref="water2" class="water w2"></div>
              <div ref="water" class="water"></div>
            </div>
            <i :class="'i-'+ i" v-for="i in 7" :key="i"></i>
          </div>

          <div class="opacityBar"></div>
          <div class="model-name">访问后购买率</div>
        </div>
        <div class="data-detail detail-visitor activeTab">
          <div class="visotor-module-title">
            <div class="module-title-tag">
              昨天访问总量：
              <span>{{shopDataYesterday.totalAccessNum ? shopDataYesterday.totalAccessNum : '0' }}</span>
            </div>
          </div>
          <div class="visitor-module-detail">
            <div>
              昨天老用户访问量：
              <span>{{shopDataYesterday.olderUserAccessNum ? shopDataYesterday.olderUserAccessNum : '0'}}</span>
            </div>
            <div>
              昨天新用户访问量：
              <span>{{shopDataYesterday.newUserAccessNum ? shopDataYesterday.newUserAccessNum : '0'}}</span>
            </div>
          </div>
        </div>
        <div class="data-detail detail-visitor">
          <div class="visotor-module-title">
            <div class="module-title-tag">
              前天访问总量：
              <span>{{shopDataDayBeforeYesterday.totalAccessNum ? shopDataDayBeforeYesterday.totalAccessNum : '0'}}</span>
            </div>
          </div>
          <div class="visitor-module-detail">
            <div>
              前天老用户访问量：
              <span>{{shopDataDayBeforeYesterday.olderUserAccessNum ? shopDataDayBeforeYesterday.olderUserAccessNum : '0'}}</span>
            </div>
            <div>
              前天新用户访问量：
              <span>{{shopDataDayBeforeYesterday.newUserAccessNum ? shopDataDayBeforeYesterday.newUserAccessNum : '0'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module-item-style">
      <div class="module-item-title-border-left">新老用户数量统计</div>
      <div id="userStatistics" style="height: 300px; width: 100%;"></div>
    </div>

    <div class="module-item-style">
      <div class="module-item-title-border-left">退换货数统计</div>
      <div id="userRetuunAndExchange" style="height: 300px; width: 100%;"></div>
    </div>

    <div class="module-item-style">
      <div class="module-item-title-border-left">下单数量、比例统计</div>
      <div class="order-statistical-container">
        <div class="order-statistical-module">
          <div class="pie-chat">
            <div id="pieChartGoods" class="pie-chat-goods"></div>
          </div>
          <div class="pie-detail">
            <div class="pie-detail-item">
              <i class="circle-icon"></i>
              <div>
                <div class="pie-detail-num">
                  {{shopDataYesterday.marketingGoodsScale ?
                  Math.round(shopDataYesterday.marketingGoodsScale * 100) : '0'}}%
                </div>
                <div class="pie-detail-title">
                  营销活动({{shopDataYesterday.marketingGoodsNum ?
                  shopDataYesterday.marketingGoodsNum : '0'}}笔)
                </div>
              </div>
            </div>
            <div class="pie-detail-item">
              <i class="circle-icon otherColor"></i>
              <div>
                <div class="pie-detail-num">
                  {{shopDataYesterday.normalGoodsScale ?
                  Math.round(shopDataYesterday.normalGoodsScale * 100) : '0'}}%
                </div>
                <div class="pie-detail-title">
                  普通商品({{shopDataYesterday.normalGoodsNum ?
                  shopDataYesterday.normalGoodsNum : '0'}}笔)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-statistical-module">
          <div class="pie-chat">
            <div id="pieChartVisitor" class="pie-chat-visitor"></div>
          </div>
          <div class="pie-detail">
            <div class="pie-detail-item">
              <i class="circle-icon"></i>
              <div>
                <div class="pie-detail-num">
                  {{shopDataYesterday.totalAccessNum ?
                  (shopDataYesterday.totalAccessNum == 0 ? '0' :
                  Math.round((shopDataYesterday.olderUserAccessNum / shopDataYesterday.totalAccessNum)
                  * 100)) : '0'}}%
                </div>
                <div class="pie-detail-title">
                  老用户({{shopDataYesterday.olderUserAccessNum ?
                  shopDataYesterday.olderUserAccessNum : '0'}}人)
                </div>
              </div>
            </div>
            <div class="pie-detail-item">
              <i class="circle-icon otherColor"></i>
              <div>
                <div class="pie-detail-num">
                  {{shopDataYesterday.totalAccessNum ?
                  (shopDataYesterday.totalAccessNum == 0 ? '0' :
                  Math.round((shopDataYesterday.newUserAccessNum / shopDataYesterday.totalAccessNum) *
                  100)) : '0'}}%
                </div>
                <div class="pie-detail-title">
                  新用户({{shopDataYesterday.newUserAccessNum ?
                  shopDataYesterday.newUserAccessNum : '0'}}人)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lineChart from "@/components/echarts/line-charts";
import echarts from "echarts";

export default {
  name: "report-shopdata",
  data() {
    return {
      chart: null,
      defaultShop: [],
      dataoptions: [],
      shopDataYesterday: {},
      shopDataDayBeforeYesterday: {},
      visitorData: {}
    };
  },
  components: {
    lineChart
  },
  computed: {
    isCollapsed() {
      return this.$store.state.app.sidebar.clapse;
    }
  },
  watch: {
    isCollapsed() {
      this.resizeCharts();
    }
  },
  created() {
    this.getmallList();
    this.getExchange();
  },
  mounted() {
    this.resizeCharts();
    window.addEventListener("resize", () => {
      this.resizeCharts();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener("resize", () => {
      this.resizeCharts();
    });
    this.chart.dispose(); // 销毁
    this.chart = null;
  },
  methods: {
    getExchange() {
      this.$http.getExchangeAPI().then(res => {
          if (res.status == 1) {
              this.initBarCharts('userRetuunAndExchange', res.data)
          }
        console.log("exchange==", res);
      });
    },
    selectChange(val) {
      console.log("val==", val);
      let mallType = val[0];
      let appId = val[val.length - 1];
      let params = {
        mallType: mallType
      };
      if (appId.length > 5) {
        params.appId = appId;
      }
      if (!params.appId && mallType == 1) {
        this.$message({
          message: "暂无对接小程序",
          type: "warning"
        });
        return false;
      }
      this.getShopData(params);
    },
    recursiveFn(arr) {
      if (arr instanceof Array) {
        arr.map(item => {
          item.value = item.appId || item.mallType;
          if (item.children.length === 0) {
            delete item.children;
          } else {
            this.recursiveFn(item.children);
          }
        });
      }
      return arr;
    },
    getmallList() {
      this.$http.getmallListAPI().then(res => {
        if (res.status == 1) {
          let listData = res.data;
          this.dataoptions = this.recursiveFn(listData);
          this.defaultShop.push(this.dataoptions[0].value);
          this.getShopData({
            mallType: this.defaultShop[0]
          });
        }
      });
    },
    getShopData(mallType) {
      console.log("mallType=", mallType);
      this.$http.getShopDataAPI(mallType).then(res => {
        console.log("shopData=", res);
        if (res.status == 1) {
          this.shopDataYesterday = res.data.yesterday;
          this.shopDataDayBeforeYesterday = res.data.dayBeforeYesterday;
          let num = -250 + 220 * this.shopDataYesterday.purchaseScale;
          this.$refs.water.style.bottom = num + "px";
          this.$refs.water1.style.bottom = num + "px";
          this.$refs.water2.style.bottom = num + "px";
          if (mallType.mallType == 0) {
            this.$message({
              message: "数据已切换到公众号商城",
              type: "success"
            });
          } else {
            this.$message({
              message: "数据已切换到小程序商城",
              type: "success"
            });
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
        let orderData = [
          {
            name: "营销活动",
            value: this.shopDataYesterday.marketingGoodsNum || 0
          },
          {
            name: "普通商品",
            value: this.shopDataYesterday.normalGoodsNum || 0
          }
        ];
        let visitorData = [
          {
            name: "老用户",
            value: this.shopDataYesterday.olderUserAccessNum || 0
          },
          {
            name: "新用户",
            value: this.shopDataYesterday.newUserAccessNum || 0
          }
        ];
        this.initPieCharts(
          "pieChartGoods",
          "昨日下单总数",
          this.shopDataYesterday.totalPurchaseNum || 0,
          orderData
        );
        this.initPieCharts(
          "pieChartVisitor",
          "昨日访问总数",
          this.shopDataYesterday.totalAccessNum || 0,
          visitorData
        );
      });

      // 获取过去7天的数据
      this.$http.getSevenDayDataAPI(mallType).then(res => {
        console.log("", res);
        if (res.status == 1) {
          this.visitorData = res.data;
          this.initLineCharts('userStatistics',res.data);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    /**
     * 重置图表
     */
    resizeCharts() {
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 350);
    },
     objOfValueToArr(object) {
        var arr = [];
        var i = 0;
        for (var item in object) {
          arr[i] = object[item];
          i++;
        }
        return arr;
      },
    /**
     * 初始化图表
     */
    initBarCharts(elId, data){
      this.chart = echarts.init(document.getElementById(elId))
      let chartData = Object.assign({}, data)
        let legendData = [] // 图例
        let xData = [] // x轴
        let seriesData = [] // x轴
        console.log('chartData==', chartData)
        xData = this.objOfValueToArr(chartData.coordinates)
        console.log('xData===', xData)

          legendData.push('退换货数')
          seriesData.push({
            name: '退换货数',
            type: 'bar',
            barWidth: '30%',
            data: Object.values(chartData['orderRefundNum'])
          })

        this.chart.setOption({
          color: ['#428EFE'],
          tooltip: {
            trigger: 'axis',
            // axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            //   type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            // }
          },
          legend: {
            show:false
          },
          grid: {
            top:'30px',
            left: '2%',
            right: '2%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            data: xData
          }],
          yAxis: [{
            type: 'value',
            minInterval:1
          }],
          series: seriesData
        })         

    },
    initLineCharts(elId, data) {
      this.chart = echarts.init(document.getElementById(elId));
      let visitorData = Object.assign({}, data);
      let legendData = []; // 图例
      let xData = []; // x轴
      let seriesData = []; // x轴
      xData = data.coordinates;
      delete visitorData.coordinates;

      for (let key in visitorData) {
        let keyName = "";
        if (key == "newUser") {
          keyName = "新用户";
          legendData.push(keyName);
        } else if (key == "olderUser") {
          keyName = "老用户";
          legendData.push(keyName);
        } else if (key == 'orderRefundNum') {
            keyName = "退换货数";
          legendData.push(keyName);
        }
        seriesData.push({
          name: keyName,
          type: "line",
          smooth: true,
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 1
            }
          },
          data: Object.values(visitorData[key])
        });
      }

      this.chart.setOption({
        barMinHeight: 8,
        color: ["#00ac9a", "#4a93ff"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#57617B"
            }
          }
        },
        legend: {
          // top: 20,
          data: legendData,
          right: "4%",
          textStyle: {
            fontSize: 12,
            color: "#888888"
          }
        },
        grid: {
          top: 40,
          left: "2%",
          right: "2%",
          bottom: "2%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#EEEEEE"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#428efe"
              }
            },
            data: xData
          }
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 2,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#EEEEEE"
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              }
            },
            splitLine: {
              lineStyle: {
                color: "#EEEEEE"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#428efe"
              }
            }
          }
        ],
        series: seriesData
      });
    },
    initPieCharts(id, title, resultNum, data) {
      let _this = this;
      this.chart = echarts.init(document.getElementById(id));
      this.chart.setOption({
        color: ["#428efe", "#f5ba48"],
        title: {
          text: title,
          subtext: resultNum.toString(),
          left: "center",
          top: "center",
          textStyle: {
            fontSize: 14,
            color: "#999999",
            align: "center"
          },
          subtextStyle: {
            fontFamily: "微软雅黑",
            fontSize: 13,
            color: "#333"
          }
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: function(params, ticket, callback) {
            let num = params.value;
            let chartTitle = params.name;
            return `<div style="text-align: center;"><div style="color: #fff;">${chartTitle}</div><div style="color: #fff;padding-top: 5px;font-weight: bold;">${num}</div></div> `;
          },
          // position: function (point, params, dom, rect, size) {
          //     //size参数可以拿到提示框的outerWidth和outerheight，dom参数可以拿到提示框div节点。
          //     //console.log(dom)可以看到，提示框是用position定位
          //     let marginW = Math.ceil(size.contentSize[0] / 2);
          //     let marginH = Math.ceil(size.contentSize[1] / 2);
          //     dom.style.marginLeft = '-' + marginW + 'px';
          //     dom.style.marginTop = '-' + marginH + 'px';
          //     return ['50%', '50%'];
          // },
          // alwaysShowContent: true,
          // backgroundColor: '#fff',	//设置提示框的背景色
          textStyle: {
            color: "#fff"
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            hoverAnimation: true, //关闭 hover 在扇区上的放大动画效果。
            cursor: "default", //鼠标悬浮时在图形元素上时鼠标的样式是什么。同 CSS 的 cursor。
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: data
          }
        ]
      });
    }
  }
};
</script>

<style scoped lang="scss">
.report-shopdata {
  .visitor-statistical-container {
    display: flex;
    justify-content: space-around;
    padding: 25px 0;
    box-sizing: border-box;

    .data-detail {
      width: 304px;
      padding: 8px 0;
      box-sizing: border-box;

      &.detail-ball {
        display: flex;
        flex-direction: column;
        align-items: center;
        @-webkit-keyframes move_wave {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 332px 0;
          }
        }

        @keyframes move_wave {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 332px 0;
          }
        }

        .boll {
          height: 200px;
          width: 200px;
          border-radius: 50%;
          border: 2px solid #428efe;
          float: left;
          position: relative;
          font-size: 14px;
          overflow: hidden;
          background-color: rgba(66, 142, 254, 0.15);
        }

        .text {
          position: absolute;
          top: 40px;
          left: 0;
          right: 0;
          text-align: center;
          color: #428efe;
          z-index: 9;
          /*color: #fff;*/
        }

        .num {
          font-size: 40px;
          font-weight: bold;
          text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;

          span {
            font-weight: normal;
            font-size: 14px;
            padding-left: 3px;
          }
        }

        .water {
          height: 250px;
          background-image: url("~@/assets/images/wave.png");
          background-repeat: repeat-x;
          background-size: 332px 100%;
          position: absolute;
          width: 100%;
          bottom: -250px;
          transform: translate(0, 0);
          animation: move_wave 4s linear both infinite;
        }

        .w1 {
          opacity: 0.5;
          background-position: 120px 0;
          animation: move_wave 8s linear both infinite;
          animation-delay: 1.5s;
        }

        .w2 {
          opacity: 0.3;
          background-position: 60px 0;
          animation: move_wave 5s linear both infinite;
          animation-delay: 3s;
        }

        i {
          position: absolute;
          bottom: -10px;
          left: 50%;
          width: 5px;
          height: 5px;
          opacity: 0;
          background: #428efe;
          border-radius: 50%;
          box-shadow: 0 0 2px #ff6a82;
          display: block;
        }

        .i-1 {
          left: 30%;
          animation: lightAni1 3s linear infinite;
        }

        .i-2 {
          animation: lightAni2 3s 1s linear infinite;
        }

        .i-3 {
          left: 10%;
          animation: lightAni1 3s 2s linear infinite;
        }

        .i-4 {
          animation: lightAni1 3s 2.2s linear infinite;
        }

        .i-5 {
          left: 60%;
          animation: lightAni3 3s 1.5s linear infinite;
        }

        .i-6 {
          animation: lightAni2 3s 0.5s linear infinite;
        }

        .i-7 {
          left: 80%;
          animation: lightAni1 3s 0.8s linear infinite;
        }

        @keyframes lightAni1 {
          0% {
            opacity: 0.5;
            transform: translateY(0);
          }
          50% {
            opacity: 1;
            transform: translateY(-100px);
          }
          100% {
            opacity: 0;
            transform: translateY(-200px);
          }
        }
        @keyframes lightAni2 {
          0% {
            opacity: 0.5;
            transform: translate(0, 0);
          }
          50% {
            opacity: 1;
            transform: translate(-30px, -100px);
          }
          100% {
            opacity: 0;
            transform: translate(-60px, -200px);
          }
        }
        @keyframes lightAni3 {
          0% {
            opacity: 0.5;
            transform: translate(0, 0);
          }
          50% {
            opacity: 1;
            transform: translate(30px, -100px);
          }
          100% {
            opacity: 0;
            transform: translate(60px, -200px);
          }
        }
      }

      .opacityBar {
        margin-top: 10px;
        width: 102px;
        height: 6px;
        background-image: radial-gradient(#fff, #eee, #fff);
        opacity: 0.61;
      }

      .model-name {
        color: #666666;
        font-size: 13px;
        margin-top: 20px;
      }

      &.detail-visitor {
        position: relative;
        box-shadow: 0px 5px 8px 0px rgba(52, 86, 135, 0.08);
        border-radius: 10px;
        border: solid 1px #f3f3f3;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        transition: all 0.6s;

        &:hover {
          transform: scale(1.1);
        }

        .visotor-module-title {
          height: 130px;

          .module-title-tag {
            display: inline-block;
            margin-top: 30px;
            color: #fff;
            font-size: 14px;
            padding: 14px 30px;
            background-color: #62a2ff;
            border-top-right-radius: 30px;
            border-bottom-right-radius: 30px;

            span {
              font-size: 20px;
            }
          }
        }

        .visitor-module-detail {
          flex: 1;
          color: #333;
          font-size: 14px;
          padding: 0 0 0 30px;
          box-sizing: border-box;
          line-height: 40px;

          span {
            color: #62a2ff;
            font-weight: bold;
            font-size: 18px;
          }
        }

        &.activeTab {
          .visotor-module-title {
            .module-title-tag {
              background-color: #2980ff;
            }
          }

          .visitor-module-detail {
            span {
              color: #428efe;
            }
          }
        }
      }
    }
  }

  .order-statistical-container {
    display: flex;
    padding: 20px;

    .order-statistical-module {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .pie-chat {
        margin-right: 30px;

        .pie-chat-goods,
        .pie-chat-visitor {
          width: 237px;
          height: 237px;
        }
      }

      .pie-detail {
        .pie-detail-item + .pie-detail-item {
          margin-top: 30px;
        }

        .pie-detail-item {
          display: flex;

          .circle-icon {
            width: 12px;
            height: 11px;
            border-radius: 50%;
            background-color: #4ca0ff;
            margin-top: 8px;
            margin-right: 10px;

            &.otherColor {
              background-color: #f5ba48;
            }
          }

          .pie-detail-num {
            font-size: 25px;
            color: #a0a2ac;
            height: 28px;
            font-weight: bold;
          }

          .pie-detail-title {
            font-size: 14px;
            color: #a0a2ac;
            padding-top: 10px;
          }
        }
      }
    }
  }
}
</style>